module.exports = __webpack_public_path__ + "img/cloudview-poster-2.314ff4c6.jpg";